import { siteUrl } from "src/api/config";
import { Fields, ListName, SPListsFields } from "../types";

export const gosSiteUrl = siteUrl + "/gos";
export const actionStatusesListName: ListName = "ActionStatuses";
export const directionsListName: ListName = "Directions";
export const documentTypesListName: ListName = "DocumentTypes";
export const governmentAgenciesListName: ListName = "GovernmentAgencies";
export const licenseStatusesListName: ListName = "LicenseStatuses";
export const locationsListName: ListName = "Locations";

export const licensesListName: ListName = "Licenses";
export const violationsListName: ListName = "Violations";
export const actionsListName: ListName = "Actions";
export const prescriptionsListName: ListName = "Prescriptions";

export const DEFAULT_LIST_MAP: Fields = {
  ID: {
    DisplayName: "ID",
    Name: "ID",
    Type: "ID",
    SelectedKey: "id",
  },
  Title: {
    DisplayName: "Title",
    Name: "Title",
    Type: "Text",
    SelectedKey: "title",
  },
};

export const INIT_DATA_LISTS: ListName[] = [
  actionStatusesListName,
  directionsListName,
  documentTypesListName,
  governmentAgenciesListName,
  licenseStatusesListName,
  locationsListName,
] as const;

export const PRESCRIPTION_MAP: Fields = {
  ...DEFAULT_LIST_MAP,
  PrescriptionNumber: {
    DisplayName: "PrescriptionNumber",
    Name: "PrescriptionNumber",
    Type: "Number",
    SelectedKey: "prescriptionNumber",
  },
  PrescriptionStatus: {
    DisplayName: "PrescriptionStatus",
    Name: "PrescriptionStatus",
    Type: "Lookup",
    ShowField: "Title",
    List: "PrescriptionStatuses",
    SelectedKey: "status",
  },
  Responsible: {
    DisplayName: "Responsible",
    Name: "Responsible",
    Type: "User",
    SelectedKey: "responsible",
  },
  Direction: {
    DisplayName: "Direction",
    Name: "Direction",
    Type: "Lookup",
    ShowField: "Title",
    List: "Directions",
    SelectedKey: "direction",
  },
  GOSLocation: {
    DisplayName: "GOSLocation",
    Name: "GOSLocation",
    Type: "Lookup",
    ShowField: "ID",
    List: "Locations",
    SelectedKey: "location",
  },
  DateVerification: {
    DisplayName: "DateVerification",
    Name: "DateVerification",
    Type: "DateTime",
    Format: "DateOnly",
    SelectedKey: "dateVerification",
  },
  DeadlineExecutionOrder: {
    DisplayName: "DeadlineExecutionOrder",
    Name: "DeadlineExecutionOrder",
    Type: "DateTime",
    Format: "DateOnly",
    SelectedKey: "deadlineExecutionOrder",
  },
  ActualClosingDatePrescription: {
    DisplayName: "ActualClosingDatePrescription",
    Name: "ActualClosingDatePrescription",
    Type: "DateTime",
    Format: "DateOnly",
    SelectedKey: "actualClosingDatePrescription",
  },
  AgencyInspection: {
    DisplayName: "AgencyInspection",
    Name: "AgencyInspection",
    Type: "Text",
    SelectedKey: "agencyInspection",
  },
  ScopeVerification: {
    DisplayName: "ScopeVerification",
    Name: "ScopeVerification",
    Type: "Text",
    SelectedKey: "scopeVerification",
  },
  TypeVerification: {
    DisplayName: "TypeVerification",
    Name: "TypeVerification",
    Type: "Text",
    SelectedKey: "typeVerification",
  },
  FieldActivity: {
    DisplayName: "FieldActivity",
    Name: "FieldActivity",
    Type: "Text",
    SelectedKey: "fieldActivity",
  },
  DepartmentsAudit: {
    DisplayName: "DepartmentsAudit",
    Name: "DepartmentsAudit",
    Type: "Text",
    SelectedKey: "departmentsAudit",
  },
  NameRegulatoryDocument: {
    DisplayName: "NameRegulatoryDocument",
    Name: "NameRegulatoryDocument",
    Type: "Text",
    SelectedKey: "nameRegulatoryDocument",
  },
  InterestedParties: {
    DisplayName: "InterestedParties",
    Name: "InterestedParties",
    Type: "User",
    SelectedKey: "interestedParties",
  },
  IdentifiedViolations: {
    DisplayName: "IdentifiedViolations",
    Name: "IdentifiedViolations",
    Type: "LookupMulti",
    List: "Violations",
    SelectedKey: "identifiedViolations",
  },
  ActionStatus: {
    DisplayName: "ActionStatus",
    Name: "ActionStatus",
    Type: "Lookup",
    ShowField: "Title",
    List: "Actions",
    SelectedKey: "actionStatus",
  },
  AmountFine: {
    DisplayName: "AmountFine",
    Name: "AmountFine",
    Type: "Text",
    SelectedKey: "amountFine",
  },
  FundsEliminationComments: {
    DisplayName: "FundsEliminationComments",
    Name: "FundsEliminationComments",
    Type: "Text",
    SelectedKey: "fundsEliminationComments",
  },
  Comments: {
    DisplayName: "Comments",
    Name: "Comments",
    Type: "Note",
    SelectedKey: "comment",
  },
  DateUpdate: {
    DisplayName: "DateUpdate",
    Name: "DateUpdate",
    Type: "DateTime",
    Format: "DateOnly",
    SelectedKey: "dateUpdate",
  },
  Violations: {
    DisplayName: "Violations",
    Name: "Violations",
    Type: "LookupMulti",
    SelectedKey: "violations",
  },
};

export const LICENSE_MAP: Fields = {
  ...DEFAULT_LIST_MAP,
  GOSLocation: {
    DisplayName: "GOSLocation",
    Name: "GOSLocation",
    Type: "Lookup",
    ShowField: "ID",
    List: "Locations",
    SelectedKey: "location",
  },
  LicenseStatus: {
    DisplayName: "LicenseStatus",
    Name: "LicenseStatus",
    Type: "Lookup",
    ShowField: "Title",
    List: "LicenseStatuses",
    SelectedKey: "status",
  },
  TypeActivity: {
    DisplayName: "TypeActivity",
    Name: "TypeActivity",
    Type: "Lookup",
    ShowField: "Title",
    List: "Activities",
    SelectedKey: "typeActivity",
  },
  DocumentType: {
    DisplayName: "DocumentType",
    Name: "DocumentType",
    Type: "Lookup",
    ShowField: "Title",
    List: "DocumentTypes",
    SelectedKey: "documentType",
  },
  NameDocument: {
    DisplayName: "NameDocument",
    Name: "NameDocument",
    Type: "Text",
    SelectedKey: "nameDocument",
  },
  DocumentNumber: {
    DisplayName: "DocumentNumber",
    Name: "DocumentNumber",
    Type: "Number",
    SelectedKey: "documentNumber",
  },
  StartDateDocument: {
    DisplayName: "StartDateDocument",
    Name: "StartDateDocument",
    Type: "DateTime",
    Format: "DateOnly",
    SelectedKey: "startDateDocument",
  },
  ExpirationDateDocument: {
    DisplayName: "ExpirationDateDocument",
    Name: "ExpirationDateDocument",
    Type: "DateTime",
    Format: "DateOnly",
    SelectedKey: "expirationDateDocument",
  },
  ValidityPeriodDocument: {
    DisplayName: "ValidityPeriodDocument",
    Name: "ValidityPeriodDocument",
    Type: "Number",
    SelectedKey: "validityPeriodDocument",
  },
  DetailedDescription: {
    DisplayName: "DetailedDescription",
    Name: "DetailedDescription",
    Type: "Note",
    SelectedKey: "detailedDescription",
  },
  GovernmentAgency: {
    DisplayName: "GovernmentAgency",
    Name: "GovernmentAgency",
    Type: "Lookup",
    ShowField: "Title",
    List: "GovernmentAgencies",
    SelectedKey: "governmentAgency",
  },
  NamesStateBody: {
    DisplayName: "NamesStateBody",
    Name: "NamesStateBody",
    Type: "Text",
    SelectedKey: "namesStateBody",
  },
  Responsible: {
    DisplayName: "Responsible",
    Name: "Responsible",
    Type: "User",
    SelectedKey: "responsible",
  },
  InterestedParties: {
    DisplayName: "InterestedParties",
    Name: "InterestedParties",
    Type: "User",
    SelectedKey: "interestedParties",
  },
  DateUpdate: {
    DisplayName: "DateUpdate",
    Name: "DateUpdate",
    Type: "DateTime",
    Format: "DateOnly",
    SelectedKey: "dateUpdate",
  },
  Comments: {
    DisplayName: "Comments",
    Name: "Comments",
    Type: "Note",
    SelectedKey: "comment",
  },
  Actions: {
    DisplayName: "Actions",
    Name: "Actions",
    Type: "LookupMulti",
    SelectedKey: "actions",
  },
  ActionStatus: {
    DisplayName: "ActionStatus",
    Name: "ActionStatus",
    Type: "Lookup",
    ShowField: "Title",
    List: "Actions",
    SelectedKey: "actionStatus",
  },
  Products: {
    DisplayName: "Products",
    Name: "Products",
    Type: "Text",
    SelectedKey: "products",
  },
  ND: { DisplayName: "ND", Name: "ND", Type: "Text", SelectedKey: "ND" },
  Code_TN_VED: {
    DisplayName: "Code_TN_VED",
    Name: "Code_TN_VED",
    Type: "Text",
    SelectedKey: "code_TN_VED",
  },
  Code_OKPD: {
    DisplayName: "Code_OKPD",
    Name: "Code_OKPD",
    Type: "Text",
    SelectedKey: "code_OKPD",
  },
  CodeTypeAlcoholicBeverages: {
    DisplayName: "CodeTypeAlcoholicBeverages",
    Name: "CodeTypeAlcoholicBeverages",
    Type: "Text",
    SelectedKey: "codeTypeAlcoholicBeverages",
  },
  CertificationBody: {
    DisplayName: "CertificationBody",
    Name: "CertificationBody",
    Type: "Text",
    SelectedKey: "certificationBody",
  },
  GTD_samples: {
    DisplayName: "GTD_samples",
    Name: "GTD_samples",
    Type: "Text",
    SelectedKey: "GTD_samples",
  },
  TransferDeclarationBroker: {
    DisplayName: "TransferDeclarationBroker",
    Name: "TransferDeclarationBroker",
    Type: "Text",
    SelectedKey: "transferDeclarationBroker",
  },
};

export const VIOLATION_MAP: Fields = {
  ...DEFAULT_LIST_MAP,
  Actions: {
    DisplayName: "Actions",
    Name: "Actions",
    Type: "LookupMulti",
    SelectedKey: "actions",
  },
};

export const ACTION_MAP: Fields = {
  ...DEFAULT_LIST_MAP,
  DateCreation: {
    DisplayName: "DateCreation",
    Name: "DateCreation",
    Type: "DateTime",
    Format: "DateOnly",
    SelectedKey: "dateCreation",
  },
  Description1: {
    DisplayName: "Description1",
    Name: "Description1",
    Type: "Note",
    SelectedKey: "description",
  },
  Meeting: {
    DisplayName: "Meeting",
    Name: "Meeting",
    Type: "Text",
    SelectedKey: "meeting",
  },
  PeriodExecution: {
    DisplayName: "PeriodExecution",
    Name: "PeriodExecution",
    Type: "DateTime",
    Format: "DateOnly",
    SelectedKey: "periodExecution",
  },
  ActionStatus: {
    DisplayName: "ActionStatus",
    Name: "ActionStatus",
    Type: "Lookup",
    ShowField: "Title",
    List: "Actions",
    SelectedKey: "status",
  },
  Responsible: {
    DisplayName: "Responsible",
    Name: "Responsible",
    Type: "User",
    SelectedKey: "responsible",
  },
};

export const GOS_LISTS: SPListsFields = {
  [actionStatusesListName]: DEFAULT_LIST_MAP,
  [directionsListName]: DEFAULT_LIST_MAP,
  [documentTypesListName]: DEFAULT_LIST_MAP,
  [governmentAgenciesListName]: DEFAULT_LIST_MAP,
  [licenseStatusesListName]: DEFAULT_LIST_MAP,
  [locationsListName]: DEFAULT_LIST_MAP,
  [licensesListName]: LICENSE_MAP,
  [violationsListName]: VIOLATION_MAP,
  [actionsListName]: ACTION_MAP,
  [prescriptionsListName]: PRESCRIPTION_MAP,
};

export type GosInitListsType = (typeof INIT_DATA_LISTS)[number];